import React, { useState } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import LocaleProvider from "./commons/LocaleProvider.jsx";
import PanelsHeader from "./commons/PanelsHeader/PanelsHeader.jsx";
import AppUniversal from "./admin/app-universal";
import ServiceProviderAppUniversal from "./serviceProvider/app-universal.jsx";
import SubAdminAppUniversal from "./subadmins/app-universal.jsx";
import ChatPage from "./commons/Chats/Chat";
import InvoiceDetails from "./commons/Billing/Invoices/InvoiceDetails";
import ClientMeetings from "./meetings-only/ClientMeetings";
import ProtectedRoutes from "./routes/ProtectedRoutes.jsx";
import SalarySlip from "./commons/Employees/SalarySlips/SalarySlip.jsx";
import PayrollReportsPage from "./serviceProvider/components/salarySlips/PayrollReportsPage.jsx";
import ContractDetails from "./serviceProvider/components/contracts/ContractDetails.jsx";
import LoginContainer from "./normalUsers/components/login/login.jsx";
import NormalUserAppUniversal from "./normalUsers/app-universal.jsx";
import Register from "./normalUsers/components/register/register.jsx";
import ConstructionHome from "./contruction-home/ConstructionHome.jsx";
// import Uberuns from "./contruction-home/components/Uberuns.jsx";
import Impressum from "./contruction-home/components/Impressum.jsx";
// import Datenschutzerklarung from "./contruction-home/components/Datenschutzerklarung.jsx";
// import Kontakt from "./contruction-home/components/Kontakt.jsx";

import Contacts from "./contruction-home/components/Contacts.jsx";
import References from "./contruction-home/components/References.jsx";
import Partner from "./contruction-home/components/Partner.jsx";
import Job from "./contruction-home/components/Job.jsx";
import Wärmedämmverbundsystem from "./contruction-home/components/Wärmedämmverbundsystem.jsx";
import Trockenbau from "./contruction-home/components/Trockenbau.jsx";
import Baumontage from "./contruction-home/components/Baumontage.jsx";
import Verputz from "./contruction-home/components/Verputz.jsx";
import treppenhausreinigung from "./contruction-home/components/Treppenhausreinigung.jsx";
import hausmeisterservice from "./contruction-home/components/Hausmeisterservice.jsx";
import gartenpflege from "./contruction-home/components/Gartenpflege.jsx";
import winterdienst from "./contruction-home/components/winterdienst.jsx";
import weitereleistungen from "./contruction-home/components/weitereleistungen.jsx";
import { PrivacyPolicy } from "./privacy-policy/PrivacyPolicy.jsx";

import CommonDocumentsManagement from "./commons/documents/DocumentsManagement.jsx";
import KeysHome from "./Key-Company/KeysHome.jsx";
import keyuberuns from "./Key-Company/components/Uberuns.jsx";
import keykontakt from "./Key-Company/components/Kontakt.jsx";
import keyDatenschutzerklarung from "./Key-Company/components/Datenschutzerklarung.jsx";
import keyImpressum from "./Key-Company/components/Impressum.jsx";
import ExchangePage from "./exChangeCode.jsx";
import PublicWorkReportSign from "./serviceProvider/components/workReports/PublicSign.jsx";
import PublicSubcontractorUpload from "./serviceProvider/components/subcontractors/PublicUpload.jsx";
import PublicChangeOrder from "./serviceProvider/components/changeOrders/PublicChangeOrder.jsx";
import PublicAcceptance from "./serviceProvider/components/warranty/PublicAcceptance.jsx";
import ActivatePortal from "./normalUsers/components/portal/ActivatePortal.jsx";

export const Appcontext = React.createContext();

const AppRouter = () => {
  const [isAuth, setIsAuth] = useState("user");
  return (
    <LocaleProvider>
      <Router basename={`/`}>
        <Appcontext.Provider value={{ isAuth, setIsAuth }}>
          <Switch>
            <Route exact path="/construction" component={ConstructionHome} />
            <Route exact path="/keys-company" component={KeysHome} />
            <Route exact path="/keys-company-uberuns" component={keyuberuns} />
            <Route exact path="/keys-company-kontakt" component={keykontakt} />
            <Route exact path="/keysdatenschutzerklarung" component={keyDatenschutzerklarung} />
            <Route exact path="/keysimpressum" component={keyImpressum} />
            <Route exact path="/impressum" component={Impressum} />
            {/* <Route exact path="/datenschutzerklarung" component={Datenschutzerklarung} /> */}
            {/*   <Route exact path="/uberuns" component={Uberuns} />
            <Route exact path="/kontakt" component={Kontakt} />*/}
            <Route exact path="/contacts" component={Contacts} />
            <Route exact path="/references" component={References} />
            <Route exact path="/partner" component={Partner} />
            <Route exact path="/job" component={Job} />
            <Route
              exact
              path="/leistungen/wärmedämmverbundsystem"
              component={Wärmedämmverbundsystem}
            />
            <Route exact path="/leistungen/trockenbau" component={Trockenbau} />
            <Route exact path="/leistungen/baumontage" component={Baumontage} />
            <Route exact path="/leistungen/verputz" component={Verputz} />
            <Route exact path="/leistungen/treppenhausreinigung" component={treppenhausreinigung} />
            <Route exact path="/leistungen/hausmeisterservice" component={hausmeisterservice} />
            <Route exact path="/leistungen/gartenpflege" component={gartenpflege} />
            <Route exact path="/leistungen/winterdienst" component={winterdienst} />
            <Route exact path="/leistungen/weitereleistungen" component={weitereleistungen} />
            {}
            {}
            <Route exact path="/privacy-policy" component={PrivacyPolicy} />
            <Route exact path="/impressum" component={Impressum} />
            <Route exact path="/exchange" component={ExchangePage} />
            <Route path="/login" component={LoginContainer} />
            <Route path="/register" exact component={Register} />
            {/* A customer signs a Regiebericht from an emailed link: no login, no app shell */}
            <Route exact path="/sign/work-report/:token" component={PublicWorkReportSign} />
            {/* A subcontractor uploads requested documents from an emailed link */}
            <Route exact path="/sub/upload/:token" component={PublicSubcontractorUpload} />
            {/* A customer approves or rejects a Nachtrag from an emailed link */}
            <Route exact path="/approve/change-order/:token" component={PublicChangeOrder} />
            {/* A customer accepts (signs) or refuses an Abnahmeprotokoll from an emailed link */}
            <Route exact path="/sign/acceptance/:token" component={PublicAcceptance} />
            {/* A customer sets the password of their portal login from the invitation email */}
            <Route exact path="/portal/activate/:token" component={ActivatePortal} />
            <PanelsHeader>
              {/* Inside the shell so chats get the app navigation (the shell already hides the
                  page header on /chats and sizes the chat to the remaining height). */}
              <ProtectedRoutes exact path="/chats" component={ChatPage} />
              <ProtectedRoutes exact path="/chat" component={ChatPage} />
              <ProtectedRoutes exact path="/meetings" component={ClientMeetings} />
              <ProtectedRoutes exact path="/documents" component={CommonDocumentsManagement} />
              <ProtectedRoutes exact path="/invoices/details/:id" component={InvoiceDetails} />
              <ProtectedRoutes
                exact
                path="/client/contract/:contractId"
                component={ContractDetails}
              />
              <ProtectedRoutes exact path="/salary/details/:id" component={SalarySlip} />
              <ProtectedRoutes exact path="/payroll/reports" component={PayrollReportsPage} />
              <Route path="/client" component={NormalUserAppUniversal} />
              <Route path="/admin" component={AppUniversal} />
              <Route path="/subadmin" component={SubAdminAppUniversal} />
              <Route path="/user" component={ServiceProviderAppUniversal} />
            </PanelsHeader>
          </Switch>
        </Appcontext.Provider>
      </Router>
    </LocaleProvider>
  );
};

export default AppRouter;
